import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import useSchoolStore from '../../store/schoolStore';

const SchoolHeader = ({ schoolHeading, schoolSubHeading, schoolAddress, iconUrl, ...props }) => {
  const { colors } = useTheme();

  const heading = schoolHeading;
  const subHeading = schoolSubHeading;
  const address = schoolAddress;
  
  // If no data is available or iconUrl is null, don't render anything
  if (!heading && !subHeading && !address) {
    return null;
  }

  return (
    <div 
      className={`py-4 px-6 ${props.className || 'text-center'}`}
      style={{ color: colors.text }}
    >
      {/* Heading with icon - larger font */}
      {heading && (
        <div className={`flex items-center mb-2 ${props.className === 'text-left' ? 'justify-start' : 'justify-center'}`}>
          {iconUrl && (
            <img 
              src={iconUrl} 
              alt="School Icon" 
              className="w-10 h-10 rounded-full object-cover mr-4"
            />
          )}
          <h1 className="text-2xl md:text-3xl font-bold text-text">
            {heading}
          </h1>
        </div>
      )}
      
      {/* Sub Heading - medium font */}
      {subHeading && (
        <h2 className="text-md md:text-lg font-semibold mb-1 text-text-secondary">
          {subHeading}
        </h2>
      )}
      
      {/* Address - smaller font */}
      {address && (
        <p className="text-sm md:text-base text-text-secondary leading-relaxed">
          {address}
        </p>
      )}
    </div>
  );
};

export default SchoolHeader;
